import { Switch } from '@trackman/web-shared-components';
import React from 'react';
import styled from 'styled-components';

export const StyledSwitch = styled((props) => <Switch {...props} />)`
  &&& {
    justify-content: start;
    height: 46px;

    .MuiTypography-root {
      font-weight: 400;
    }
  }
`;
